var _path, _path2, _mask, _g, _ellipse, _ellipse2, _g2, _ellipse3, _ellipse4, _ellipse5, _path3, _ellipse6, _mask2, _g3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpilledCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 127,
    viewBox: "0 0 298 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 104.713L136.826 96L191.739 107.686L91.9183 119.372L86 104.713Z",
    fill: "#8692AC",
    fillOpacity: 0.37,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 97.2521L58.3437 95L111.344 95.556L27.8269 105.832L0 97.2521Z",
    fill: "#8692AC",
    fillOpacity: 0.37,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 88.8552C3 88.8552 10.337 100.584 19.0061 103.384C39.0975 109.872 55.7902 114.686 69.0843 117.823C97.6297 124.561 116.429 107.73 116.429 107.73C116.429 107.73 165.117 112.295 189.947 107.73C197.537 106.335 221.721 99.7413 221.721 99.7413L108.226 71C108.226 71 94.0707 83.3906 78.2332 86.5072C71.5206 87.8281 50.5505 91.9613 25.5229 91.9613C14.1425 91.9613 3 88.8552 3 88.8552Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.972 56.152C247.801 40.7293 237.183 29.2363 228.252 27.4989L133.727 5.5L126.26 90.8484L226.528 85.3622C237.371 85.3622 246.143 71.5748 246.972 56.152Z",
    fill: "url(#coffee6)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "coffee1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 5,
    width: 125,
    height: 97
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.972 56.152C247.801 40.7293 237.183 29.2363 228.252 27.4989L133.727 5.5L126.26 90.8484L226.528 85.3622C237.371 85.3622 246.143 71.5748 246.972 56.152Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#coffee1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.319 13.1758L204.744 21.0608C204.744 21.0608 214.941 34.1493 215.451 53.8032C215.96 73.4571 201.228 90.8239 201.228 90.8239L166.013 93.3386C166.013 93.3386 183.023 74.8274 182.818 52.1359C182.613 29.4444 171.319 13.1758 171.319 13.1758Z",
    fill: "url(#coffee11)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.491,
    cy: 49.2179,
    rx: 27.5,
    ry: 47,
    transform: "rotate(5 130.491 49.2179)",
    fill: "url(#coffee7)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.037,
    cy: 48.6761,
    rx: 21,
    ry: 39.5,
    transform: "rotate(5 130.037 48.6761)",
    fill: "url(#coffee10)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#coffee2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.775 51.3926C139.548 58.91 126.945 71.8523 121.908 73.3255C116.871 74.7988 107.077 77.2147 106.327 83.3277C105.577 89.4408 96.6471 91.3274 88.7057 92.4006C80.7643 93.4737 64.7173 93.7387 63.3898 97.61C62.0622 101.481 89.2337 101.481 98.8623 101.481C108.491 101.481 131.828 100.795 134.841 99.4609C137.854 98.1273 135.716 90.2661 138.214 83.3277C140.713 80.5133 148.449 73.2165 150.775 51.3926Z",
    fill: "url(#coffee8)"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.5,
    cy: 95.1667,
    rx: 3.5,
    ry: 1.16667,
    fill: "#C39078"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.5,
    cy: 96.5,
    rx: 1.5,
    ry: 0.5,
    fill: "#C39078"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.5,
    cy: 97.5,
    rx: 1.5,
    ry: 0.5,
    fill: "#B38670"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224 112H298L296 121C296 121 288.684 127 260.644 127C232.603 127 226 121 226 121L224 112Z",
    fill: "url(#coffee9)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261,
    cy: 111.5,
    rx: 37,
    ry: 7.5,
    fill: "url(#coffee3)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "coffee5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 104,
    width: 74,
    height: 15
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 261,
    cy: 111.5,
    rx: 37,
    ry: 7.5,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#coffee5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 261,
    cy: 117.5,
    rx: 35,
    ry: 7.5,
    fill: "url(#coffee4)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.434 49.2894L189.414 54.0801C189.414 54.1453 189.422 54.2101 189.439 54.273C190.116 59.2546 192.871 60.3412 193.759 60.5643C193.846 60.5996 193.939 60.618 194.034 60.6185L203.858 60.6605C205.375 60.6657 206.609 59.4439 206.617 57.9299L206.654 49.3631C206.659 47.849 205.435 46.6168 203.918 46.609L192.193 46.5588C190.677 46.5537 189.442 47.7754 189.434 49.2894Z",
    fill: "url(#paint8_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M193.303 56.1289C193.306 55.4195 192.732 54.842 192.021 54.8389L190.165 54.831C189.825 54.829 189.529 54.5994 189.443 54.2712C190.117 59.2529 192.872 60.3394 193.76 60.5625C193.47 60.45 193.28 60.1717 193.28 59.8616L193.303 56.1289Z",
    fill: "#FBFBFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.681 53.6164C199.69 51.4115 201.236 49.642 203.148 49.6502C203.47 49.6516 203.729 49.9127 203.728 50.2334C203.726 50.5542 203.465 50.8131 203.143 50.8117C201.883 50.8063 200.851 52.0671 200.845 53.6214C200.838 55.1757 201.859 56.4477 203.119 56.4531C203.336 56.4401 203.541 56.5482 203.653 56.7338C203.765 56.9193 203.764 57.1514 203.65 57.336C203.537 57.5206 203.331 57.627 203.114 57.6122C201.202 57.604 199.672 55.8118 199.681 53.6164Z",
    fill: "#5096DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "coffee2",
    x: 46.3428,
    y: 26.3926,
    width: 117.432,
    height: 80.0888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807779 0 0 0 0 0.847247 0 0 0 0 0.86352 0 0 0 0.484771 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee6",
    x1: 163.69,
    y1: 51.1223,
    x2: 159.279,
    y2: 101.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee11",
    x1: 163.833,
    y1: 23.4065,
    x2: 202.017,
    y2: 83.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357ABC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee7",
    x1: 231.235,
    y1: -16.7153,
    x2: 146.474,
    y2: -36.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee10",
    x1: 86.4789,
    y1: 70.8914,
    x2: 150.986,
    y2: 87.1035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee8",
    x1: 98.0107,
    y1: 119.751,
    x2: 136.567,
    y2: 73.6224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89635A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee9",
    x1: 248.356,
    y1: 100.334,
    x2: 244.522,
    y2: 132.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee3",
    x1: 306.612,
    y1: 108.16,
    x2: 297.559,
    y2: 79.9978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee4",
    x1: 234.475,
    y1: 107.599,
    x2: 233.273,
    y2: 120.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 195.067,
    y1: 60.9191,
    x2: 200.993,
    y2: 51.4506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CACDD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E3E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpilledCoffee);
export default __webpack_public_path__ + "static/media/spilled-coffee.975bfb986aa2c89bde45e6981d8a7822.svg";
export { ForwardRef as ReactComponent };